let IDCode = localStorage.getItem("Consultant_id");

let NavList = [
  {
    text: "Home",
    Icon: "HomeIcon",
    children: [{ Name: "Home", Path: "Consultant", NewTab: false }],
  },
  {
    text: "Pages",
    Icon: "RememberMeIcon",
    children: [
      {
        Name: "End Of Year Commission",
        Path: "Consultant/EndOfYear",
        NewTab: false,
      },
      {
        Name: "Bookings",
        Path: "Consultant/ConsultantBookings",
        NewTab: false,
      },
      
      {
        Name: "Invoices",
        Path: "Consultant/ConsultantInvoices",
        NewTab: false,
      },
      {
        Name: "Letters",
        Path: "Consultant/ConsultantLetters",
        NewTab: false,
      },
      {
        Name: "Materials",
        Path: "Consultant/ConsultantMaterials",
        NewTab: false,
      },
    ],
  },
  // {
  //   text: "Forms",
  //   Icon: "ChecklistIcon",
  //   children: [
  //     // {
  //     //   Name: "Test",
  //     //   Path: "Consultant/ConsultantTest",
  //     //   NewTab: false,
  //     // },
  //     {
  //       Name: "Book Now",
  //       // Path: `Public/RegistrationForm/${localStorage.getItem(
  //       //   "Consultant_id"
  //       // )}`,
  //       Path: `Public/RegistrationForm/${IDCode}`,
  //       NewTab: true,
  //     },
  //     {
  //       Name: "Sign Up A Colleague",
  //       Path: `Public/ECSignUpForm/${IDCode}`,
  //       NewTab: true,
  //     },
  //   ],
  // },
  {
    text: "Settings",
    Icon: "SettingsIcon",
    children: [
      {
        Name: "Settings",
        Path: "Consultant/ConsultantSettings",
        NewTab: false,
      },
    ],
  },
];

export default NavList;
